import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ThemeToggle from '../components/ThemeToggle';
import { signIn } from '../auth/session';

export default function SignIn() {
  const nav = useNavigate();
  const loc = useLocation();
  const from = (loc.state as { from?: string } | null)?.from ?? '/';
  const [empId, setEmpId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  async function go() {
    if (!empId.trim() || password.length < 6) return;
    setBusy(true); setErr('');
    try {
      const r = await signIn(empId, password);
      if (r.ok) nav(from, { replace: true });
      else { setErr(r.message); setPassword(''); }
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Sign in failed. Check your connection.');
    } finally {
      setBusy(false);
    }
  }

  const canSubmit = !!empId.trim() && password.length >= 6 && !busy;

  return (
    <div className="signin">
      <div className="signin-orb a" />
      <div className="signin-orb b" />
      <div className="signin-theme"><ThemeToggle /></div>

      <div className="signin-card">
        <div className="signin-mark">
          <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M13 2 3 14h7l-1 8 11-14h-7l0-6Z" />
          </svg>
        </div>
        <h1>UNM Electrical</h1>
        <p className="signin-sub">Sign in with your Employee ID</p>

        <div className="signin-field">
          <label htmlFor="emp">Employee ID</label>
          <div className="box">
            <input
              id="emp" autoCapitalize="characters" autoComplete="username" placeholder="E001"
              value={empId} onChange={(e) => setEmpId(e.target.value.toUpperCase())}
              onKeyDown={(e) => { if (e.key === 'Enter') void go(); }}
            />
          </div>
        </div>

        <div className="signin-field">
          <label htmlFor="pw">Password</label>
          <div className="box">
            <input
              id="pw" type={showPassword ? 'text' : 'password'} autoComplete="current-password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') void go(); }}
            />
            <button
              type="button" className="signin-eye" onClick={() => setShowPassword((s) => !s)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? '🙈' : '👁'}
            </button>
          </div>
        </div>

        <button className="signin-submit" onClick={() => void go()} disabled={!canSubmit}>
          {busy ? 'Signing in…' : 'Sign In'}
        </button>

        {err && <p className="signin-error">{err}</p>}
        <p className="signin-hint">Forgot your password? Ask an admin to reset it in Operators.</p>
      </div>
    </div>
  );
}
